export default function checkResponseUploadFile(data) {
  const errors = Object.values(data);

  return errors;
}
